import React from 'react'

const clients = [
  { name: 'AMZ Fastlane', url: 'https://www.amz-fastlane.com/' },
  { name: 'Apex Palantir', url: 'https://apex-palantir.com/' },
  { name: 'Biroul Notarial BNP Romanu', url: 'https://www.bnpromanu.ro/' },
  { name: 'BeyondNow', url: 'https://www.beyondnow.com/en/' },
]

const TrustedBy = () => {
  return (
    <section id="trusted-by" className="trusted-by">
      <div className="container trusted-by-container">
        <h2 className="section-title">Trusted By</h2>
        <div className="client-grid">
          {clients.map((client, index) => (
            <a href={client.url} key={index} className="client-card" target="_blank" rel="noopener noreferrer">
               <img src={`/clients/${client.name.toLowerCase().replace(/\s+/g, '-')}.png`} alt={client.name} className="client-logo" />
              {/* <img src={`/clients/logo192.png`} alt={client.name} className="client-logo" /> */}
              <span className="client-name">{client.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TrustedBy